module.exports = "/images/arrow-out.png?0fe49b6b7f0031be824e3a520f895702";